import {
  PagedListData,
  PagedListRequest,
  PagedListResult,
} from '../models/paged-list.model';

/** Maps backend list payload (`items` / `data`, `totalRecords` / `totalCount`) to a single shape. */
export function normalizePagedList<T>(
  data: PagedListData<T> | null | undefined,
): PagedListResult<T> {
  const items = data?.items ?? data?.data ?? [];
  const totalRecords = data?.totalRecords ?? data?.totalCount ?? items.length;
  return {
    items,
    totalRecords,
    pageNumber: data?.pageNumber,
    pageSize: data?.pageSize,
  };
}

export function createPagedListRequest(
  partial: Partial<PagedListRequest> & Pick<PagedListRequest, 'sortColumn'>,
): PagedListRequest {
  return {
    pageNumber: partial.pageNumber ?? 1,
    pageSize: partial.pageSize ?? 10,
    searchTerm: partial.searchTerm ?? null,
    sortColumn: partial.sortColumn,
    sortDirection: partial.sortDirection ?? 'ASC',
  };
}

export function totalPagesFrom(
  totalRecords: number,
  pageSize: number,
): number {
  return Math.max(1, Math.ceil(totalRecords / Math.max(1, pageSize)));
}
